import { Divider, Skeleton, Stack } from '@mantine/core'

import ModalHeader from '../../shared/ModalHeader/ModalHeader'

export const Initializing = () => {
    return (
        <Stack className="p-4">
            <Skeleton className="h-20 2xl:h-8 lg:h-10" />
            <Divider className="animate-pulse" />
            <Skeleton className="2xl:h-20 lg:h-24 h-28" />
            <Skeleton className="2xl:h-20 lg:h-24 h-28" />
            <Skeleton className="2xl:h-20 lg:h-24 h-28" />
            <Skeleton className="h-10 ml-auto w-28 lg:h-8 lg:w-20" />
        </Stack>
    )
}

export const InitializingTitle = () => {
    const metadata = {
        title: 'Chargement...',
        description: 'Création de votre commande en cours...',
    }
    return <ModalHeader {...metadata} />
}
